import ResultsAppBar from "../layout/ResultsAppBar";
import { Box } from "@mui/material";
import { CompetitionsContextProvider } from "../../contexts/CompetitionsContext";
import { Outlet } from "react-router-dom";

export default function Root() {
  return (
    <CompetitionsContextProvider>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
          backgroundColor: "background.default",
        }}
      >
        <ResultsAppBar />
        <Box component="main" sx={{ flexGrow: 1 }}>
          <Outlet />
        </Box>
      </Box>
    </CompetitionsContextProvider>
  );
}
